import { Button, Col, Row, Select, Breadcrumb } from "antd";
import { useMutation, useQuery } from "react-query";
import { PermissionsList } from "./PermissionsList";
import {
  editRole,
  getRoleById,
  getRoles,
  getRolesDropdown,
} from "../../api/roles";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getInitialPermissions } from "../../api/roles";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import Title from "../UI/Title/Title";
import { Link, useLocation } from "react-router-dom";
import ResetButton from "../UI/ResetButton/resetbutton";

// return array of numbers
export const extractCheckedIds = (array: any[]): number[] => {
  return array.flatMap((resource) => {
    return resource.permissions
      .filter((permission: any) => permission.isChecked)
      .map((checkedPermission: any) => checkedPermission.id);
  });
};

//center table
function Permissions() {
  const { t } = useTranslation("common");
  const [formatedRoles, setFormatedRoles] = useState();
  const [checkedPermissions, setCheckedPermissions] = useState<number[]>([]);
  const [permissions, setPermissions] = useState<any>();
  const [role, setRole] = useState<any | undefined>();

  const { state } = useLocation();

  const { roleId } = state ?? { recordId: 1 };

  //const navigate = useNavigate();
  const { isLoading, data: roles } = useQuery("roles", getRolesDropdown, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setFormatedRoles(
        res.data.map((role: any) => {
          return { value: role.id, label: role.name };
        })
      );
    },
  });

  const { mutateAsync: getPermissionsMutation } = useMutation(
    "getPermissions",
    (id: string) => getRoleById(id)
  );

  const onCheckboxChange = (permissionId: number) => {
    if (checkedPermissions.includes(permissionId)) {
      // If ID already exists in array, remove it
      setCheckedPermissions(
        checkedPermissions.filter(
          (existingId: number) => existingId !== permissionId
        )
      );
    } else {
      // If ID doesn't exist in array, add it
      const tempArr: number[] = checkedPermissions.map((perm) => perm);
      tempArr.push(permissionId);
      setCheckedPermissions(tempArr);
    }
  };

  const handleRoleChange = (e: number) => {
    getPermissionsMutation(`${e}`).then((res) => {
      setCheckedPermissions(extractCheckedIds(res.data.permissions));
      setRole(res.data);
    });
  };

  const { mutateAsync: permissionsMutation } = useMutation(
    "premissions",
    getInitialPermissions
  );
  const { mutateAsync: initRoles } = useMutation("initRole", () =>
    getRoleById(roleId)
  );

  const { mutateAsync: editRoleMutation } = useMutation(
    "editRole",
    (body: any) => editRole(body)
  );

  const handleEditRole = (body: any) => {
    editRoleMutation(body)
      .then(() => {
        console.log("success");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const resetFilters = () => {
    setTableKey((tableKey) => tableKey + 1);
    setCheckedPermissions([]);
  };
  const [tableKey, setTableKey] = useState(1000);

  useEffect(() => {
    permissionsMutation().then((res) => {
      setPermissions(res);
    });
    initRoles().then((initRole) => {
      setCheckedPermissions(extractCheckedIds(initRole.data.permissions));
      setRole(initRole.data);
    });
  }, []);

  return (
    <>
      <Row gutter={[0, 10]}>
        <Col offset={1} span={22}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("system")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">{`${t(
                    "permissions"
                  )}`}</span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("permissions")}`} />
        </Col>
        <Col offset={1} span={3}>
          <Select
            size="large"
            key={tableKey}
            style={{ width: "100%" }}
            options={formatedRoles}
            onChange={(e) => handleRoleChange(e)}
            placeholder={`${t("select-role")}`}
            showSearch={true}
            optionFilterProp="label"
            defaultValue={roleId}
          />
        </Col>
        <Col
          offset={17}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <ResetButton
            onClick={() => {
              resetFilters();
            }}
          />
        </Col>

        <Col offset={1} span={22} className="users-list">
          <PermissionsList
            tableKey={tableKey}
            roles={roles?.data}
            loading={isLoading}
            permissions={permissions?.data}
            onCheckboxChange={onCheckboxChange}
            checkedPermissions={checkedPermissions}
          />
        </Col>
        <Col
          span={16}
          offset={1}
          style={{
            marginTop: "1%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <CancelBtn data-testid="cancel-button" />
        </Col>
        <Col
          offset={2}
          span={4}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
            marginTop: "1%",
          }}
        >
          <Col style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="primary"
              size="large"
              className="all-btns next"
              onClick={() => {
                handleEditRole({
                  id: role.id,
                  permissionIds: checkedPermissions,
                  name: role.name,
                  description: role.description,
                  isActive: role.isActive,
                  isSystem: role.isSystem,
                });
              }}
            >
              {t("save")}
            </Button>
          </Col>
        </Col>
      </Row>
    </>
  );
}

export default Permissions;
